module.exports = __webpack_public_path__ + "assets/img/img3.38497669.png";